import { Button } from '@mui/material';
import type { ReactElement } from 'react';
import type { ICustomButtonProps } from '../../types/ITypes';

export const CustomButton = (props: ICustomButtonProps): ReactElement => {
  return (
    <Button
      variant={props.variant}
      className={`text-capitalize p-5px mr-5px common-btn ${props.className ?? ''}`}
      disabled={props.disabled}
      onClick={(): void => props.handleAction(props.type)}
      startIcon={props.startIcon}
    >
      {props.label}
    </Button>
  );
};
